export default __webpack_public_path__ + "chat-sm.6e92b6c2.svg";